/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The FilePiecemealSnapshotIdBody model module.
 * @module model/FilePiecemealSnapshotIdBody
 * @version v0
 */
export default class FilePiecemealSnapshotIdBody {
  /**
   * Constructs a new <code>FilePiecemealSnapshotIdBody</code>.
   * @alias module:model/FilePiecemealSnapshotIdBody
   * @class
   * @param file {Blob} 
   */
  constructor(file) {
    this.file = file;
  }

  /**
   * Constructs a <code>FilePiecemealSnapshotIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FilePiecemealSnapshotIdBody} obj Optional instance to populate.
   * @return {module:model/FilePiecemealSnapshotIdBody} The populated <code>FilePiecemealSnapshotIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new FilePiecemealSnapshotIdBody();
      if (data.hasOwnProperty('file'))
        obj.file = ApiClient.convertToType(data['file'], 'Blob');
    }
    return obj;
  }
}

/**
 * @member {Blob} file
 */
FilePiecemealSnapshotIdBody.prototype.file = undefined;

